'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg8 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 8, height: 6, viewBox: "0 0 8 6", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.195.362c.26-.26.683-.26.943 0L4 3.224 6.862.362a.667.667 0 0 1 .943.943L4.47 4.638a.667.667 0 0 1-.942 0L.195 1.305a.667.667 0 0 1 0-.943", fill: "#1BA672" })));

exports.default = Svg8;
//# sourceMappingURL=8.js.map
